import home from './home'
import calendar from './calendar'

const course = {
  path: 'course',
  component: resolve => require(['../../../pages/teacher/course'], resolve),
  redirect: 'course/home',
  children: [
    home,
    calendar
  ]
}
export default course



// WEBPACK FOOTER //
// ./src/router/teacher/course/index.js